/**
 * VaultManager Page — Standalone page for managing secrets vault
 * Route: /vault-manager
 */

import { AdminVault } from '../components/admin/AdminVault';
import { isAdmin } from '../stores/auth.store';
import { route } from 'preact-router';
import { useEffect } from 'preact/hooks';
import { T } from '../styles/tokens';

export function VaultManagerPage() {
  useEffect(() => {
    // Redirect non-admins to home
    if (!isAdmin.value) {
      route('/');
    }
  }, []);

  if (!isAdmin.value) {
    return null;
  }

  return (
    <div>
      <AdminVault />
    </div>
  );
}
